/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Commission_Type_Enum =
  | 'CUSTOM'
  | 'NO_COMMISSION'
  /** 5% commission on order value */
  | 'STANDARD_5_PERCENT'
  /** 10% commission on order value */
  | 'STANDARD_10_PERCENT';

/** input type for updating data in table "contract" */
export type Contract_Set_Input = {
  buyingCompanyId?: string | null | undefined;
  catalog_id?: string | null | undefined;
  channel_url?: string | null | undefined;
  created_at?: string | null | undefined;
  custom_price_list_id?: string | null | undefined;
  custom_sdd_payment_delay?: number | null | undefined;
  discount?: number | null | undefined;
  id?: string | null | undefined;
  introduced_by_kheops?: boolean | null | undefined;
  is_trusted_supplier?: boolean | null | undefined;
  minimum_order_value?: number | null | undefined;
  minimum_order_value_type?: Minimum_Order_Value_Type_Enum | null | undefined;
  payment_method?: Payment_Method_Enum | null | undefined;
  proposer_business_profile?: Business_Profile_Enum | null | undefined;
  proposer_user_id?: string | null | undefined;
  reference_id?: string | null | undefined;
  status?: Contract_Status_Enum | null | undefined;
  sub_catalog_id?: string | null | undefined;
  /** Non-nullable is only applied by supplier_commission_type_constraint */
  supplier_commission_type?: Commission_Type_Enum | null | undefined;
  supplier_custom_commission_rate?: number | null | undefined;
  supplyingCompanyId?: string | null | undefined;
  updated_at?: string | null | undefined;
  updated_by?: string | null | undefined;
};

export type Contract_Status_Enum =
  | 'SIGNED'
  | 'UNSIGNED';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Payment_Method_Enum =
  | 'BANK_TRANSFER'
  | 'NO_PAYMENT'
  | 'SDD_AUTO'
  | 'SDD_TRIGGERED';

export type UpdateContractsMutationVariables = Exact<{
  contractIds: Array<string> | string;
  contractInput: Types.Contract_Set_Input;
}>;


export type UpdateContractsMutation = { update_contract_many: Array<{ affected_rows: number } | null> | null };


export const UpdateContractsDocument = /*#__PURE__*/ gql`
    mutation UpdateContracts($contractIds: [uuid!]!, $contractInput: contract_set_input!) {
  update_contract_many(
    updates: {where: {id: {_in: $contractIds}}, _set: $contractInput}
  ) {
    affected_rows
  }
}
    `;
export type UpdateContractsMutationFn = Apollo.MutationFunction<UpdateContractsMutation, UpdateContractsMutationVariables>;

/**
 * __useUpdateContractsMutation__
 *
 * To run a mutation, you first call `useUpdateContractsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractsMutation, { data, loading, error }] = useUpdateContractsMutation({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *      contractInput: // value for 'contractInput'
 *   },
 * });
 */
export function useUpdateContractsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractsMutation, UpdateContractsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractsMutation, UpdateContractsMutationVariables>(UpdateContractsDocument, options);
      }
export type UpdateContractsMutationHookResult = ReturnType<typeof useUpdateContractsMutation>;
export type UpdateContractsMutationResult = Apollo.MutationResult<UpdateContractsMutation>;
export type UpdateContractsMutationOptions = Apollo.BaseMutationOptions<UpdateContractsMutation, UpdateContractsMutationVariables>;